import CountryCode from "models/CountryCode";

export default function getLocationCountryCode(
    locationValue: string,
    defaultCountryCode: CountryCode = CountryCode.GB
) {
    if (locationValue.length !== 2) return defaultCountryCode;

    const countryCodeKeys = Object.keys(CountryCode);

    for (let i = 0; i < countryCodeKeys.length; i++) {
        const key = countryCodeKeys[i];

        // @ts-ignore
        const value: CountryCode = CountryCode[key];

        if (value.toUpperCase() === locationValue.toUpperCase()) return value;
    }

    return defaultCountryCode;
}
